import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, Input, SimpleChanges, ViewChild } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatTab, MatTabGroup, MatTabLabel } from "@angular/material/tabs";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Timestamp } from "firebase/firestore";
import { BehaviorSubject, Observable, Subscription, interval, throwError } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { SocialService } from "src/app/services/social.service";
import { UserManagementService } from "src/app/services/user-management.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { FilterYoursToPlay } from "../../../pipe/yours-to-play/yoursToPlay";
import { CountDownTimerComponent } from "../../count-down-timer/count-down-timer.component";
import { InProgressAnimationComponent } from "../../in-progress-animation/in-progress-animation.component";
import { CommunitySubtabsComponent } from "../community-subtabs/community-subtabs.component";
import { HeroAreaComponent } from "../hero-area.component";
import { GamesLeaderboardComponent } from "./games-leaderboard/games-leaderboard.component";
import { JoinPoupComponent } from "./join-poup/join-poup/join-poup.component";
import { SocialGamePreviewComponent } from "./social-game-preview/social-game-preview.component";

@Component({
    selector: "app-games-subtabs",
    templateUrl: "./games-subtabs.component.html",
    styleUrls: ["./games-subtabs.component.scss"],
    standalone: true,
    imports: [
        MatTabGroup,
        MatTab,
        MatTabLabel,
        NgClass,
        IonicModule,
        SwiperModule,
        MatProgressSpinner,
        CountDownTimerComponent,
        NgStyle,
        InProgressAnimationComponent,
        GamesLeaderboardComponent,
        AsyncPipe,
        FilterYoursToPlay,
        TranslatePipe,
    ],
})
export class GamesSubtabsComponent {
  @ViewChild("gameMission") public gameMission: SwiperComponent;
  getUserGameDiscoveryDetails$ = new BehaviorSubject(null);
  getHallofFame$ = new BehaviorSubject(null);
  getLeaderPlayerWeek$ = new BehaviorSubject(null);
  leaderPlayerMonth$ = new BehaviorSubject(null);
  getMissionData$ = new BehaviorSubject(null);
  @Input() currentTab: number;
  selectedLanguage: string;
  previous: Data;
  previousmonth: Data;
  previousWeek: Data;
  public spanish: boolean;
  public selectedCard: number;
  isDisable: boolean = false;
  buttonText = "Join";
  userAlreadyJoined = false;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: Observable<number>;
  sub: Subscription;
  proceed = true;
  public userId: string;

  constructor(
    private matDialog: MatDialog,
    private socialService: SocialService,
    private authService: AuthService,
    public translate: TranslateService,
    private afs: AngularFirestore,
    private changeDetectorRef: ChangeDetectorRef,
    private sheet: MatBottomSheetRef<HeroAreaComponent>,
    private matbottomsheet: MatBottomSheet,
    private router: Router,
    private userManagementService: UserManagementService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data
  ) {
    this.currentTab = data.currentTab;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("GamesSubtabsComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.socialService?.leaderBoardData$.subscribe((d) => {
      this.getLeaderPlayerWeek$.next(d[1]);
    });
    this.socialService?.gamingMissionData$.subscribe((d) => {
      this.getMissionData$.next(d);
    });
    this.socialService.socialGamesLeaderBoardHallOfFame().then((d) => {
        this.getHallofFame$.next(d);
      }).catch((err) => {
        return err;
      });

    this.getHallofFame$?.pipe(filter((f) => f != null)).subscribe(async (data) => {
      this.previous = data?.previous_list;
    });
    this.socialService.GamesLeaderBoardPlayerMonth().then((d) => {
        this.leaderPlayerMonth$.next(d);
      }).catch((err) => {
        return err;
      });
    this.leaderPlayerMonth$?.pipe(filter((f) => f != null)).subscribe(async (data) => {
      this.previousmonth = data?.previous_list;
    });
    this.socialService?.getUserGameDiscoveryDetails().then((d) => {
        this.getUserGameDiscoveryDetails$.next(d);
      }).catch((err) => {
        return err;
      });
    this.getUserGameDiscoveryDetails$.pipe(filter((f) => f != null)).subscribe(async (d) => {
      for (let element in d) {
        for (let s of d[element]) {
          this.authService.getDVFromString(s?.gameData?.["top_prize"]).then(async (dvString: string) => {
              s["top_prize"] = dvString;
            }).catch((err) => {
              return err;
            });;
        }
      }
    });
    this.getUserGameDiscoveryDetails$.pipe(filter((f) => f != null)).subscribe(async (d) => {
      for (let element in d) {
        for (let s of d[element]) {
          this.authService
            .getDVFromString(s?.gameData?.content?.[this.selectedLanguage]?.["game_short_title"])
            .then(async (dvString: string) => {
              s["game_short_title"] = dvString;
            }).catch((err) => {
              return err;
            });;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.socialService.getMissionData().then((d) => {
        this.getMissionData$.next(d);
      }).catch((err) => {
        return err;
      });
    if (changes && changes?.currentTab?.currentValue) {
      if (changes?.currentTab?.currentValue === 0) {
        this.currentTab = 0;
      } else if (changes.currentTab.currentValue === 1) {
        this.currentTab = 1;
      } else if (changes.currentTab.currentValue === 2) {
        this.currentTab = 2;
      } else if (changes.currentTab.currentValue === 3) {
        this.currentTab = 3;
      } else {
        this.currentTab = 0;
      }
    } else {
      this.currentTab = 0;
    }
  }

  public slideOpts: SwiperOptions = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1.25,
    spaceBetween: 10,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
  };
  // This is for the Mission cards  slider parameters
  public cardSlide: SwiperOptions = {
    initialSlide: 1,
    speed: 400,
    slidesPerView: 1.1,
    pagination: true,
    centeredSlides: false,
  };
  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        return err;
      }
    );
  }

  async JoinMission() {
    const userData = await this.userManagementService?.userDetailsForHome$.pipe(first()).toPromise();
    if (userData) {
      let snapshot;
      if (typeof userData.peepso_group === "string") {
        snapshot = await this.afs
          .doc(
            `/Global_lookup/peepso_user_groups/${userData?.country_name}/${userData?.peepso_group}/missions/gaming_list`
          )
          .get()
          .toPromise();
      } else {
        const peepso_group_url = userData?.peepso_group;
        const path = peepso_group_url["path"];
        snapshot = await this.afs.doc(`${path}/missions/gaming_list`).get().toPromise();
      }
      if (snapshot?.exists) {
        const currentData = snapshot?.data();
        for (let key of Object.keys(currentData)) {
          if (key === "update_timestamp" || key === "creation_timestamp") {
            continue;
          }
          const ref = currentData["current"].get();
          const data = await this.socialService.allPromises(ref, "current");
          this.getAsyncData(data.contributors.get());

          if (data?.join_user) {
            let userAlreadyJoined = data?.join_user.some((user) => user.user_id === this.userId);
            if (!userAlreadyJoined) {
              data.join_user.push({
                user_id: this.userId,
                wp_user_id: parseInt(localStorage.getItem("wp_user_id")),
              });
              currentData["current"].update(data).then(() => {
                  this.socialService.getMissionData().then((d) => {
                    this.getMissionData$.next(d);
                    this.matDialog.open(JoinPoupComponent, {
                      panelClass: "join-mission-dialog",
                      backdropClass: "cashout-back-drop-color",
                    });
                    this.stopSpinner();
                  });
                }).catch((error) => {
                  return error;
                });
            }
          }
        }
      }
    }
  }
  getAsyncData(ref) {
    return new Promise((resolve, reject) => {
      if (!ref) {
        reject(false);
      }
      if (ref) {
        const userId = this.userId;
        const wpUserId = parseInt(localStorage.getItem("wp_user_id"));
        this.getGxpByUserId(wpUserId).subscribe(
          (gxp) => {
            const newContributor = {
              user_id: userId,
              wp_user_id: wpUserId,
              gxp: gxp,
            };
            ref.then((d) => {
                const data = d?.data() || {};
                if (!data?.top_contributors) {
                  data.top_contributors = [newContributor];
                } else {
                  const existingContributor = data?.top_contributors.find((contributor) => contributor.user_id === userId);
                  if (!existingContributor) {
                    data.top_contributors.push(newContributor);
                  }
                }
                d?.ref
                  .set(data)
                  .then(() => {
                    resolve(data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              })
              .catch((error) => {
                return error;
              });
          },
          (error) => {
            reject(error);
          }
        );
      }
    });
  }

  getGxpByUserId(wp_user_id) {
    if (wp_user_id) {
      return this.getLeaderPlayerWeek$.pipe(
        map((data) => data?.current_list.find((contributor) => contributor.wp_user_id == wp_user_id)?.gxp)
      );
    }
  }

  getButtonText(missionData) {
    const userId = this.userId;
    if (missionData) {
      let userAlreadyJoined = missionData?.join_user.some((user) => user.user_id === userId);
      if (userAlreadyJoined) {
        this.userAlreadyJoined = true;
        return this.translate.get("missions.Contribution");
      } else {
        this.userAlreadyJoined = false;
        return this.translate.get("missions.Join");
      }
    }
    return this.translate.get("missions.Join");
  }
  stopSpinner() {
    this.progressBar === 100;
    this.sub?.unsubscribe();
    this.spinnerAnimation = false;
    this.proceed = true;
    this.changeDetectorRef.detectChanges();
  }
  getDiff(listOne) {
    if (!listOne) return -1;
    const current = this.previous.find((e) => e?.wp_user_id === listOne.wp_user_id)?.gxp;
    if (!current) return -1;
    return current - listOne.gxp;
  }
  getMonth(listOne) {
    if (!listOne) return -1;
    const current = this.previousmonth.find((e) => e?.wp_user_id === listOne.wp_user_id)?.gxp;
    if (!current) return -1;
    return current - listOne.gxp;
  }
  getWeek(listOne) {
    if (!listOne) return -1;
    const current = this.previousWeek.find((e) => e.wp_user_id === listOne.wp_user_id)?.gxp;
    if (!current) return -1;
    return current - listOne.gxp;
  }
  openGamePreview(gameDetails) {
    this.matDialog.open(SocialGamePreviewComponent, {
      panelClass: "socialgamePreview",
      backdropClass: "opnotification-backdrop-color",
      data: gameDetails,
    });
  }
  getPercent(curr: number, tar: number): number {
    const percent = (curr / tar) * 100;
    return percent | 0;
  }
  getweeks(weeks) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const d = new Date(weeks.seconds * 1000);
    return days[d.getDay()];
  }

  getRank(data) {
    const userId = parseInt(localStorage.getItem("wp_user_id"));
    if (Number.isNaN(userId) || !data || !Array.isArray(data) || data.length === 0) {
      return null;
    }
    const sortedData = data.sort((a, b) => b.fxp - a.fxp);
    const userIndex = sortedData.findIndex((d) => d.wp_user_id === userId);
    if (userIndex < 0) {
      return null;
    }
    return userIndex + 1;
  }
  public onSlideChange() {
    this.selectedCard = this.gameMission?.swiperRef?.activeIndex;
  }
  checkCards(currentRestData) {
    if (currentRestData) {
      if (currentRestData && currentRestData?.end && currentRestData?.end instanceof Timestamp) {
        if (currentRestData?.end.toDate() < new Date()) {
          return "completed";
        }

        if (currentRestData?.end.toDate() > new Date()) {
          if (currentRestData?.start && currentRestData?.start instanceof Timestamp) {
            if (currentRestData?.start.toDate() <= new Date()) {
              return "join";
            }
          }
        }

        if (currentRestData?.start && currentRestData?.start instanceof Timestamp) {
          if (currentRestData?.start.toDate() > new Date() && currentRestData?.end.toDate() > new Date()) {
            this.isDisable = true;
            return "joinWithDisable";
          }
        }
      }
    }
  }

  // This private method opens a bottom sheet to display the CommunitySubtabsComponent
  private openCommnuityTab() {
    this.matbottomsheet.open(CommunitySubtabsComponent, {
      panelClass: "fortune-mat-bottomsheet",
      backdropClass: "FortuneDiscover-backdrop",
      hasBackdrop: true,
      data: { currentTab: 3 },
    });
  }

  // This is method has been to Handle the game page navigation according to the game category
  navigateToGamePage(game: Data) {
    // All variables contain the game category, game id and game type id
    try {
      const gameCategory = game?.gameData?.category;
      const gameID = game?.gameData?.game_id;
      const gameTypeId = game?.gameData?.game_type_id;
      const gameAdventureId = game?.gameData?.adventure_id;
      if (
        gameTypeId !== null &&
        gameTypeId !== undefined &&
        gameID !== null &&
        gameID !== undefined &&
        gameCategory !== null &&
        gameCategory !== undefined
      ) {
        // This is switch case for the game category
        switch (gameCategory) {
          // This is for Instant Win
          case "Instant Win":
            this.sheet.dismiss();
            this.router.navigateByUrl(`games/instant-win-game/${gameID}`);
            break;
          // This is for Skill
          case "Skill":
            this.sheet.dismiss();
            if (gameTypeId !== 10) {
              this.router.navigateByUrl(`games/skill-game/${gameID}`);
            } else if (gameTypeId === 10) {
              this.router.navigateByUrl(`games/replayable/${gameID}`);
            }
            break;
          // This is for Rapid Fire
          case "Rapid Fire":
            this.sheet.dismiss();
            this.router.navigateByUrl(`games/rapid-fire-game/${gameID}`);
            break;
          // This is for Adventure
          case "Adventure":
            this.sheet.dismiss();
            this.router.navigateByUrl(`games/adventure-game/${gameAdventureId}`);
            break;
        }
      } else {
        return throwError("No game data found");
      }
    } catch (error) {
      // Handling the error
      return throwError(error);
    }
  }
}
